import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Col, Form, Row } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { TiposSocioConstant } from 'constants/index'

import { DateHandler } from 'utils'

import * as FormGroups from './formGroups'

export const ValidationSchema = Yup.object().shape({
  numeroDocumento: Yup.string().required(),
  importe: Yup.number().required(),
  fechaVencimiento: Yup.string().notRequired(),
  dias: Yup.string().notRequired()
})

const LetraCabeceraSection = ({ dispatch, vFechaEmision, vTipoSocio, siguienteCorrelativo }) => {
  const __zariContext = React.useContext(ZariContext)

  const inputNumeroDocumentoRef = React.useRef(null)

  const formInitialValues = React.useMemo(() => {
    let numeroDocumento = ''
    if (vTipoSocio === TiposSocioConstant.CLIENTE && siguienteCorrelativo) {
      numeroDocumento = siguienteCorrelativo
    }

    return {
      numeroDocumento: numeroDocumento,
      importe: '',
      fechaVencimiento: '',
      dias: ''
    }
  }, [vTipoSocio, siguienteCorrelativo])

  const onSubmit = React.useCallback(
    (data, { resetForm, setSubmitting }) => {
      const newData = {
        ...data
      }

      if (!newData.dias && !newData.fechaVencimiento) {
        __zariContext.snack('error', 'Ingresar fecha de vencimiento o días para el cálculo.')
        setSubmitting(false)
        return
      }

      if (newData.dias) {
        const parsedDias = parseFloat(data.dias)
        const fechaEmisionDate = DateHandler.parse(vFechaEmision)
        const fechaVencimientoDate = DateHandler.add(fechaEmisionDate, { days: parsedDias })
        const fechaVencimientoStr = DateHandler.format(fechaVencimientoDate)

        newData.fechaVencimiento = fechaVencimientoStr
      } else if (newData.fechaVencimiento) {
        const fechaEmisionDate = DateHandler.parse(vFechaEmision)
        const fechaVencimientoDate = DateHandler.parse(newData.fechaVencimiento)

        const diasDiferencia = DateHandler.differenceInDays(fechaVencimientoDate, fechaEmisionDate)
        newData.dias = diasDiferencia
      }

      const fechaEmisionDate = DateHandler.parse(vFechaEmision)
      const fechaVencimientoDate = DateHandler.parse(newData.fechaVencimiento)
      const diasDiferencia = DateHandler.differenceInDays(fechaVencimientoDate, fechaEmisionDate)

      if (diasDiferencia < 0) {
        __zariContext.snack('error', 'La fecha vencimiento es menor a la fecha de emisión.')
        setSubmitting(false)
        return
      }

      let numeroDocumento = ''
      if (vTipoSocio === TiposSocioConstant.CLIENTE) {
        const numeroDocumentoAnterior = parseFloat(newData.numeroDocumento)
        if (isNaN(numeroDocumentoAnterior)) {
          __zariContext.snack('error', 'El número documento ingresado no es válido.')
          setSubmitting(false)
          return
        }

        numeroDocumento = numeroDocumentoAnterior + 1
      }

      dispatch({ type: 'agregar', payload: newData })

      resetForm({
        values: {
          ...formInitialValues,
          numeroDocumento: numeroDocumento,
          importe: '',
          fechaVencimiento: '',
          dias: ''
        },
        isSubmitting: false
      })

      inputNumeroDocumentoRef.current.focus()
    },
    [formInitialValues, dispatch, __zariContext, vFechaEmision, vTipoSocio]
  )

  return (
    <>
      <Formik
        initialValues={formInitialValues}
        onSubmit={onSubmit}
        validationSchema={ValidationSchema}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Row>
              <Col md={3}>
                <FormGroups.NumeroDocumentoFormGroup
                  iError={errors.numeroDocumento}
                  iTouched={touched.numeroDocumento}
                  fIsSubmitting={isSubmitting}
                  innerRef={inputNumeroDocumentoRef}
                />
              </Col>
              <Col md={2}>
                <FormGroups.ImporteFormGroup iError={errors.importe} iTouched={touched.importe} fIsSubmitting={isSubmitting} />
              </Col>
              <Col md={3}>
                <FormGroups.FechaVencimientoFormGroup
                  iError={errors.fechaVencimiento}
                  iTouched={touched.fechaVencimiento}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col md={2}>
                <FormGroups.DiasFormGroup iError={errors.dias} iTouched={touched.dias} fIsSubmitting={isSubmitting} />
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label text='&ensp;' md={12} />
                  <Col md={12}>
                    <Button id='nuevaletra-agregar-button' block onClick={handleSubmit}>
                      Agregar
                    </Button>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default React.memo(LetraCabeceraSection)
